import { SYNC_TYPEN, hinweisFuer, type SyncTyp } from '@/lib/syncTypes'

// ============================================================
//  Die Typwahl — an EINER Stelle gebaut, an zwei Stellen benutzt
//
//  Sie steht bewusst direkt neben dem Knopf, den sie betrifft: eine Wahl,
//  die weit weg von ihrer Wirkung sitzt, wird beim Klicken vergessen.
// ============================================================

export default function SyncTypeSelect({
  wert,
  onChange,
  disabled,
  label,
  id,
  mitHinweis = true,
}: {
  wert: SyncTyp
  onChange: (naechster: SyncTyp) => void
  disabled?: boolean
  /** Beschriftung fuer Screenreader — im Gedraenge der Zeile steht kein sichtbarer Text. */
  label: string
  id: string
  /**
   * Soll der Hinweistext mitlaufen? Heute JA an beiden Stellen — auch in der
   * Profilzeile, denn dort ist der Reparaturfall je Profil zu Hause. Der
   * Schalter bleibt, weil eine kuenftige, noch engere Darstellung ihn
   * brauchen koennte; er steht auf `true`, und ein Test haelt das.
   */
  mitHinweis?: boolean
}) {
  const hinweis = hinweisFuer(wert)

  return (
    <div className="flex flex-col items-end gap-1">
      <select
        id={id}
        aria-label={label}
        aria-describedby={mitHinweis && hinweis ? `${id}-hinweis` : undefined}
        value={wert}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as SyncTyp)}
        className="h-7 rounded-md border border-[var(--border)] bg-[var(--card)] px-2 text-xs font-medium text-[var(--foreground)] disabled:cursor-not-allowed disabled:opacity-50"
      >
        {SYNC_TYPEN.map((t) => (
          <option key={t.wert} value={t.wert}>
            {t.label}
          </option>
        ))}
      </select>
      {mitHinweis && hinweis ? (
        <span
          id={`${id}-hinweis`}
          role="status"
          className="max-w-[22rem] text-right text-[11px] leading-snug text-[var(--muted-foreground)]"
        >
          {hinweis}
        </span>
      ) : null}
    </div>
  )
}
